<template>
    <el-select :value="value" :multiple="multiple" :collapse-tags="collapse" filterable @input="$emit('input', $event)"
        placeholder="选择分类" :size="size" style="width:100%" clearable remote reserve-keyword :remote-method="remoteMethod"
        :multiple-limit="0" allow-create>
        <el-option v-for="item in filteredOptions" :key="item.name" :label="item.name" :value="item.name">
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'selectExpertCategory',
    props: {
        value: {
            // type: [Array],
            default: () => []
        },
        size: {
            default: 'small'
        },
        collapse: {
            default: true
        },
        multiple:{
            default: true
        }
    },
    data() {
        return {
            options: [],
            filteredOptions: []
        }
    },
    methods: {
        remoteMethod(query) {
            if (query) {
                this.filteredOptions = this.options.filter((option) =>
                    option.name.toLowerCase().includes(query.toLowerCase())
                )
            } else {
                this.filteredOptions = this.options
            }
        },
        async getData() {
            const resp = await this.$http.get('/expert/dict/category?page=1&pageSize=5000')
            this.options = resp.data
            this.filteredOptions = resp.data
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped></style>
